import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'UPLOAD_QUITUS_FOURN',
  title: 'Wie kann ich die Ordnerübersicht meines Nachunternehmers herunterladen?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Die Ordnerübersicht ist die Zusammenfassung der Dokumente Ihres Nachunternehmers auf OFA.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Um sie herunterzuladen:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf den Register " Nachunternehmer"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_UPLOAD_QUITUS_FOURN/DE_UPLOAD_QUITUS_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf die Schaltfläche " Nachweisübersicht herunterladen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_UPLOAD_QUITUS_FOURN/DE_UPLOAD_QUITUS_FOURN_2.png`
  }]
};
